import {AssignmentType} from './assignement-type';
import {AbstractPeriodParametersLoaderService} from '../../parameters/services/abstract-period-parameters-loader.service';

export class AbstractMarkWeightLoaderService extends AbstractPeriodParametersLoaderService<number> {
    constructor(private readonly assignmentType: AssignmentType) {
        super('assignments/' + assignmentType);
    }
}
